import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// companies
import { AddCompanyComponent } from 'src/app/components/setup/companies/add/add.component';
import { ListCompanyComponent } from 'src/app/components/setup/companies/list/list.component';
import { EditCompanyComponent } from 'src/app/components/setup/companies/edit/edit.component';
// customers
import { ListCustomerComponent } from 'src/app/components/setup/customers/list/listcustomer.component';
import { AddCustomerComponent } from 'src/app/components/setup/customers/add/addcustomer.component';
import { EditCustomerComponent } from 'src/app/components/setup/customers/edit/editcustomer.component';
// products
import { AddProductComponent } from 'src/app/components/setup/products/add/add.component';
import { ListProductComponent } from 'src/app/components/setup/products/list/list.component';
import { EditProductComponent } from 'src/app/components/setup/products/edit/edit.component';
import { AddContractComponent } from '../../components/setup/customers/contract/addcontract.component'; 
//zones
import { ZoneLinkComponent } from '../../components/setup/zones/link/zone.component'; 
import { ListZonesComponent } from 'src/app/components/setup/zones/list/listzones.component';

import { AssetsComponent } from 'src/app/components/setup/assets/assets.component';
import { AddZoneComponent } from '../../components/setup/zones/add/add.component';

const routes: Routes = [
  { path: 'companies', component: ListCompanyComponent },
  { path: 'companies/add', component: AddCompanyComponent },
  { path: 'companies/edit/:id', component: EditCompanyComponent },

  { path: 'customers', component: ListCustomerComponent },
  { path: 'customers/add', component: AddCustomerComponent },
  { path: 'customers/edit/:id', component: EditCustomerComponent },
  { path: 'customers/:id/contract', component: AddContractComponent },

  { path: 'products', component: ListProductComponent },
  { path: 'products/add', component: AddProductComponent },
  { path: 'products/edit/:id', component: EditProductComponent },
  
  { path:'zones', component: ListZonesComponent },
  { path:'zones/link', component: ZoneLinkComponent },
  { path:'zones/add', component: AddZoneComponent },
  
  { path: 'general', loadChildren: () => import('./general/general.module').then(g => g.GeneralModule) },
  { path: 'vendors', loadChildren: () => import('./vendors/vendors.module').then(g => g.VendorsModule) },
  { path: 'geo', loadChildren: () => import('./geo/geo.module').then(g => g.GeoModule) },
  { path: 'assets', component: AssetsComponent }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SetupRoutingModule { }
